import { Link } from 'react-router-dom';
import { dramaCategories, dramas } from '@/mocks/dramas';

const categoryMeta: Record<string, { icon: string; desc: string }> = {
  经济犯罪: { icon: 'ri-money-cny-circle-line', desc: '借贷、担保、资金链与合同纠纷' },
  社会纪实: { icon: 'ri-community-line', desc: '打拐寻亲、基层治理与群体处境' },
  法治观察: { icon: 'ri-scales-3-line', desc: '举证责任、劳动维权与程序正义' },
  都市民生: { icon: 'ri-building-2-line', desc: '新业态用工、住房与城市生活压力' },
  反诈前线: { icon: 'ri-shield-cross-line', desc: '电信诈骗、劝返与反诈宣传题材' },
  科技伦理: { icon: 'ri-cpu-line', desc: '数据安全、隐私边界与技术责任' },
};

const latest = [...dramas].sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1)).slice(0, 5);

export default function CategorySection() {
  return (
    <section id="categories" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12">
          <div className="lg:col-span-2">
            <p className="font-label text-xs tracking-[0.25em] text-primary-600 mb-3">
              BROWSE BY GENRE / 按题材翻
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              六大题材分区，直接跳到你想看的方向
            </h2>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {dramaCategories.map((cat) => {
                const meta = categoryMeta[cat];
                const count = dramas.filter((d) => d.category === cat).length;
                return (
                  <Link
                    key={cat}
                    to={`/dramas?cat=${encodeURIComponent(cat)}`}
                    className="group flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-accent-400 hover:bg-accent-50/50 transition-colors"
                  >
                    <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors">
                      <i className={`${meta.icon} text-xl`}></i>
                    </span>
                    <span className="min-w-0">
                      <span className="flex items-center gap-2">
                        <span className="font-heading text-base font-bold text-foreground-950">
                          {cat}
                        </span>
                        <span className="font-label text-[11px] text-foreground-400">
                          {count > 0 ? `${count} 部已归档` : '持续更新'}
                        </span>
                      </span>
                      <span className="mt-1 block text-xs text-foreground-500 leading-relaxed">
                        {meta.desc}
                      </span>
                    </span>
                    <i className="ri-arrow-right-up-line text-foreground-300 ml-auto group-hover:text-accent-600 transition-colors"></i>
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
              <div className="px-5 py-4 border-b border-background-200 flex items-center gap-2">
                <i className="ri-history-line text-primary-600"></i>
                <h3 className="font-heading text-base font-bold text-foreground-950">最新核对档案</h3>
              </div>
              <ul>
                {latest.map((drama) => (
                  <li key={drama.id} className="border-b border-background-200 last:border-none">
                    <Link
                      to={`/dramas/${drama.id}`}
                      className="block px-5 py-3.5 hover:bg-background-200/40 transition-colors"
                    >
                      <span className="flex items-center justify-between gap-3">
                        <span className="text-sm font-medium text-foreground-900 truncate">
                          《{drama.title}》
                        </span>
                        <span className="font-label text-[11px] text-foreground-400 shrink-0">
                          {drama.publishDate.slice(5)}
                        </span>
                      </span>
                      <span className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                        <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">
                          {drama.category}
                        </span>
                        <span>{drama.confirmLevel}</span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/dramas"
                className="flex items-center justify-center gap-2 px-5 py-3.5 text-sm text-primary-600 hover:bg-primary-50 transition-colors"
              >
                浏览全部档案
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}